import Config from '@/config';
import http from './http';

export default {
  getSupplier: (id) => http.post(`${Config.apiHost}/contractor/receiptOrder/getSupplier/`, { id }),
  save: (params) => http.post(`${Config.apiHost}/contractor/receiptOrder/save/`, params),
  getAvailableItemsOnSupplier: (id, supplierId) => http.post(`${Config.apiHost}/contractor/receiptOrder/getAvailableItemsOnSupplier/`, { id, supplierId }),
};
